// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNavigationLink-module--cls1--1f7Hs","cls2":"SideNavigationLink-module--cls2--g69rJ SideNavigationLink-module--cls1--1f7Hs"};